module.exports = __webpack_public_path__ + "img/logoArty2.ac92ca2e.png";